import {closeKendoWindow, openCloseWindow, openKendoWindow, windowTriggers} from '../global/kendoWindows';

export default function () {
    let $soxItem = $('.soxexc__item');
    if ($soxItem.length) {
        setPanelBar();
        attachButtonEvents();
        removeAttachment();
    }
    windowTriggers();
    openCloseWindow();
}

const getQueryVariable = (variable) => {
    let query = window.location.search.substring(1), vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    console.error(`Query variable ${variable} not found`);
};

const removeAttachment = () => {
    let $isRecordRole = $('#isRecordRole');
    if ($isRecordRole.length && $isRecordRole.val() !== 'True' && getQueryVariable('type') === 'needed') {
        //Remove Attachment things
        $('[class^=dropZoneElement]').parent().remove();
        $('.k-dropzone').remove();
        $('.k-upload-button').remove();
        $('.k-button.l-delete').remove();
    }
};

const setPanelBar = () => {
    let $soxPanel = $('.pannelbar--sox-exc');
    if ($soxPanel.length) {
        $soxPanel.kendoPanelBar({
            expandMode: 'multiple'
        });
    }
};

const attachButtonEvents = () => {
    let $saveButtons = $('[data-role="save"]');
    let $approveButtons = $('[data-role="approve"]');
    let $rejectButtons = $('[data-role="reject"]');

    if ($saveButtons.length) {
        $saveButtons.click(function () {
            let soxId = $(this).parents('form').attr('data-sox-id');
            saveBfcException(soxId);
        });
    }

    if ($approveButtons.length) {
        $approveButtons.click(function () {
            let soxId = $(this).parents('form').attr('data-sox-id');
            approveBfcException(soxId);
        });
    }

    if ($rejectButtons.length) {
        $rejectButtons.click(function () {
            let soxId = $(this).parents('form').attr('data-sox-id');
            OpenRejectionReasonWindow(soxId, getQueryVariable('type') === 'submitted');
        });
    }
};

const saveBfcException = (soxId) => {
    let $form = $('#BfcExceptionModelForm' + soxId), url = '/Compliance/Sox/SaveBfcExceptions?' + $form.serialize(), data = {}, $error = $form.find('[id^=errorMsg]'), errorText = null;
    $error.hide();
    if ($form.find('#Explanation').val() === '' || $form.find('input[type=radio]:checked').length === 0) {
        errorText = 'Please make sure all information is completed';
    }

    if (errorText !== null) {
        $error.text(errorText);
        $error.show();
        return;
    }

    $.post(url, data, function () {
        removeException(soxId);
    }).fail(function () {
        $error.text('Failed to Save Exception Data');
        $error.show();
    });
};

const approveBfcException = (soxId) => {
    const $form = $('#BfcExceptionModelForm' + soxId), url = '/Compliance/Sox/ApproveBfcExceptions?' + $form.serialize(), data = {
        pin: $($form).find('#pin_id').val()
    };

    if (data.pin === '') {
        $('#errorMsg' + soxId).text('Please Enter your PIN to proceed').show();
        return;
    }

    $.post(url, data, function (response) {
        if (response !== 'Success') {
            $('#errorMsg' + soxId).text(response).show();
            return;
        }
        removeException(soxId);
    });
};

export const rejectBfcException = (soxId) => {
    const form          = $('#BfcExceptionModelForm' + soxId), url = '/Compliance/Sox/RejectBfcExceptions?' + form.serialize(), data = {
        pin: $(form).find('#pin_id').val()
    }, $rejectionReason = $('#rejectReason');
    if ($rejectionReason.val() === '') {
        $rejectionReason.addClass('fieldValidationError');
        return;
    }
    if (data.pin === '') {
        $('#errorMsg' + soxId).text('Please Enter your PIN to proceed').show();
        return;
    }

    closeKendoWindow($('#RejectionReasonWindow'));
    $rejectionReason.val('');

    $.post(url, data, function (response) {
        if (response !== 'Success') {
            $('#errorMsg' + soxId).text(response).show();
            return;
        }
        removeException(soxId);
    });
};

const OpenRejectionReasonWindow = (soxId, skipPin) => {
    const $form = $('#BfcExceptionModelForm' + soxId), data = {
        pin: $($form).find('#pin_id').val() || ''
    };
    if (data.pin === '' && !skipPin) {
        $('#errorMsg' + soxId).text('Please Enter your PIN to proceed').show();
        return;
    }
    let $rejectionWindow = $('#RejectionReasonWindow');

    if ($rejectionWindow.length) {
        $rejectionWindow.find('#currentSoxId').val(soxId);
        openKendoWindow($rejectionWindow);
    }
};

export const updateRejectionReason = (soxId, value) => {
    $('#BfcExceptionModelForm' + soxId + ' [name=RejectionReason]').val(value);
};

const removeException = (soxId) => {
    const $form                                                         = $('#BfcExceptionModelForm' + soxId),
          $parent                                                       = $form.parent(),
          $card                                                         = $parent.parent().parent(),
          title                                                         = $parent.find('.soxexc__title').text(), $cardException = $card.find(`[data-exception="${title}"]`).parent();
    if ($card.find('form').length > 1) {
        $cardException.remove();
        $parent.remove();
    } else {
        $card.remove();
    }
    const $formDiv = $('div#bfcExceptionsForm .pannelbar--sox-exc');
    if (!$('.soxexc').length) {
        $formDiv.append('<p class="t-italic t-muted">There are no exceptions for the selected month</p>');
    }
};
